import { mount } from 'svelte';
import App from './App.svelte';
import './styles/tokens.css';
import './styles/base.css';
import { registerBinderServiceWorker } from './lib/offline/pwa-update';
import { flushPendingServerLogout } from './lib/auth/session';
import { syncMutationQueue } from './lib/offline/queue';

registerBinderServiceWorker();

window.addEventListener('online', () => {
  void flushPendingServerLogout();
  void syncMutationQueue();
});

void flushPendingServerLogout();
void syncMutationQueue();

mount(App, {
  target: document.getElementById('app')!
});
